import React from 'react';
import FooterView from './footerView';

const FooterContainer = () => {
  return <FooterView />;
};

export default FooterContainer;
